<button
  type="button"
  puButton
  size="s"
  uiType="secondary"
  (click)="openExchangeRate()">
  <pu-icon iconName="exchange" size="16"> </pu-icon>
  {{ 'shell.header.rateConditions.exchangeRates' | translate }}
</button>

<button
  type="button"
  puButton
  size="s"
  uiType="secondary"
  (click)="openConditionsAndFees()">
  <pu-icon iconName="fees" size="16"> </pu-icon>
  {{ 'shell.header.rateConditions.conditionsFees' | translate }}
</button>
